import React from 'react';
import { HTMLSelect, HTMLSelectProps } from '@blueprintjs/core';
import { Select as BPSelect, SelectProps } from '@blueprintjs/select';

const GenericSelect = BPSelect.ofType<any>();

/**
 * children prop is the <Select/> popover target
 * usually is <Button/>
 */
const Select: React.FC<SelectProps<any>> = ({ children, ...props }) => {
  return <GenericSelect {...props}>{children}</GenericSelect>;
};

export default Select;

export const SimpleSelect: React.FC<HTMLSelectProps> = (props) => {
  return <HTMLSelect {...props} />;
};
